import iframeMessenger, {initDefaultListeners} from './iframe-messenger'

iframeMessenger.init()
initDefaultListeners()
